import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import { CaseForms } from "../../../../helpers/enums";

import './DisattivazioneDellaFornituraCase.scss';
import useSimpleCaseData from "../../../../hooks/useSimpleCaseData";

const DisattivazioneDellaFornituraCase = () => {
  const {data, blockCaseIfNoContract} = useSimpleCaseData();
  return (
    <div
      className="DisattivazioneDellaFornituraCase"
      data-testid="DisattivazioneDellaFornituraCase"
    >
      <CaseGenerator
        type={CaseForms.DisattivazioneDellaFornitura}
        initialValues={data}
        blockIfNoContracts={blockCaseIfNoContract}
      />
    </div>
  );
};


export default DisattivazioneDellaFornituraCase;
